module.exports = __webpack_public_path__ + "casper-21e40080.png";